import { ApolloError, useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { CompanyUserQueryDocument } from './companyUserId.gql';

interface CompanyUserIdResult {
  companyUserId?: string;
  loading: boolean;
  error?: ApolloError;
}

const useCompanyUserId = (): CompanyUserIdResult => {
  const { companyProfileId } = useCompanyContext();

  const { data, error, loading } = useQuery(CompanyUserQueryDocument, {
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId as string },
  });

  const companyUserId =
    loading === false && error === undefined
      ? data?.viewer.companyUser.companyUserId
      : undefined;

  return {
    companyUserId,
    error,
    loading,
  };
};

export default useCompanyUserId;
